import { render } from "./HeadingBlock.vue?vue&type=template&id=84ac18e2&scoped=true"
import script from "./HeadingBlock.vue?vue&type=script&lang=js"
export * from "./HeadingBlock.vue?vue&type=script&lang=js"

import "./HeadingBlock.vue?vue&type=style&index=0&id=84ac18e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ac18e2"]])

export default __exports__